// Classes
import OrdemServicoItem  from "@/entities/OrdemServicoItem/OrdemServicoItem"
// Services
import OrdensServicoService from "@/services/Registros/OrdensServicoService"
// utils
import { realToCents } from "@/utils/conversors"
import moment from "moment"

class OrdemServico {
  constructor (data) {
    this.ordem_servico_id = null
    this.cpf_solicitante = null
    this.nome_solicitante = null
    this.registro_id = null
    this.cartorio_id = null
    this.numero = null
    this.itens = []
    this.valor_total = null
    this.num_pedido_crc = null
    this.cumprida = null
    this.data_cumprida = moment().format('YYYY-MM-DD')
    this.cancelada = null
    this.data_cancelamento = null
    this.uf_cartorio = null
    this.num_matricula_registro = null
    this.valor_da_custa = null
    this.num_selo = null
    this.observacoes = null
    this.cx_pedido_id = null
    this.mensalista_id = null
    this.created_at = null
    this.updated_at = null

    // States para o front
    this.existeSelo = false

    if (data) this.__init(data)
  }

  __init (data) {
    Object.assign(this, data)
    if (data.itens && data.itens.length) {
      this.itens = data.itens.map((item) => new OrdemServicoItem(item))
    } 
  }

  async reload (id) {
    if (!id && !this.ordem_servico_id) {
      throw Error('O id da ordem de serviço deve ser informado')
    }
    const os = await OrdensServicoService.showOS(id || this.ordem_servico_id)
    if (os) this.__init(os)
    return this
  }

  setItemOrdemServico (item) {
    this.itens.push(item)
  }

  getExisteSelosAtivos () {
    let selosQtd = 0

    this.itens.map(ordemServico => {
      if (ordemServico.seloItemOs && ordemServico.seloItemOs.length > 0 && !ordemServico.flag_cancelado) {
        ordemServico.seloItemOs.map(selo => {
          if (!!selo) {
            selosQtd++
          }
        })
      }
    })

    return selosQtd
  }

  valorTotal () {
    let valor = 0
    if (!this.itens.length) return valor
      valor = this.itens
        .filter((item) => {
          return !item.flag_cancelado
        })
        .reduce((a, x) =>  realToCents(a.valor) || realToCents(a) + realToCents(x.valor), 0)
    this.valor_total = parseInt(valor)
    return valor
  }
}

export default OrdemServico